import brandLogos from '../Assets/BrandLogos/brandLogos';

export const Newsletters = {
  INSIDE_LANE: 'insideLane',
  THE_PREP: 'thePrep',
  MINT_PILLOW: 'mintPillow',
  DENTAL_BITE: 'dentalBite',
  RAISE_THE_BAR: 'raiseTheBar',
  THE_NET_GAINS: 'theNetGains',
  THE_LEVEL: 'theLevel',
  THE_SKUPE: 'theSKUpe',
};

export const NewsletterConfig = {
  [Newsletters.INSIDE_LANE]: {
    logo: brandLogos.insideLane,
    logoAltText: 'Inside Lane logo',
    image:
      '/newsletter-assets/inside-lane-newsletter-interstitial-product-image.png',
    imageAltText: 'Inside Lane newsletter',
    id: 'INSIDE_LANE',
  },
  [Newsletters.THE_PREP]: {
    logo: brandLogos.thePrep,
    logoAltText: 'The Prep logo',
    image:
      '/newsletter-assets/the-prep-newsletter-interstitial-product-image.png',
    imageAltText: 'The Prep newsletter',
    id: 'THE_PREP',
  },
  [Newsletters.MINT_PILLOW]: {
    logo: brandLogos.mintPillow,
    logoAltText: 'Mint Pillow logo',
    image:
      '/newsletter-assets/mint-pillow-newsletter-interstitial-product-image.png',
    imageAltText: 'Mint Pillow newsletter',
    id: 'MINT_PILLOW',
  },
  [Newsletters.DENTAL_BITE]: {
    logo: brandLogos.dentalBite,
    logoAltText: 'Dental Bite logo',
    image:
      '/newsletter-assets/dental-bite-newsletter-interstitial-product-image.png',
    imageAltText: 'Dental Bite newsletter',
    id: 'DENTAL_BITE',
  },
  [Newsletters.RAISE_THE_BAR]: {
    logo: brandLogos.raiseTheBar,
    logoAltText: 'Raise the Bar logo',
    image:
      '/newsletter-assets/raise-the-bar-newsletter-interstitial-product-image.png',
    imageAltText: 'Raise the Bar newsletter',
    id: 'RAISE_THE_BAR',
  },
  [Newsletters.THE_NET_GAINS]: {
    logo: brandLogos.theNetGains,
    logoAltText: 'The Net Gains logo',
    image:
      '/newsletter-assets/the-net-gains-newsletter-interstitial-product-image.png',
    imageAltText: 'The Net Gains newsletter',
    id: 'THE_NET_GAINS',
  },
  [Newsletters.THE_LEVEL]: {
    logo: brandLogos.theLevel,
    logoAltText: 'The Level logo',
    image:
      '/newsletter-assets/the-level-newsletter-interstitial-product-image.png',
    imageAltText: 'The Level newsletter',
    id: 'THE_LEVEL',
  },
  [Newsletters.THE_SKUPE]: {
    logo: brandLogos.theSKUpe,
    logoAltText: 'The SKUpe logo',
    image:
      '/newsletter-assets/the-skupe-newsletter-interstitial-product-image.png',
    imageAltText: 'The SKUpe newsletter',
    id: 'THE_SKUPE',
  },
};
